import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Navigation from '../components/Navigation';
import logo from '../musicology-white.svg';


const styles = theme => ({
  white: {
    color: theme.palette.common.white
  },
  container: {
    padding: 20
  },
  flex: {
    flex: 1
  },
  bar: {
    padding: 10,
  },
});


class Header extends Component {

  render() {
    const { classes } = this.props;

    return (
      <AppBar position="static" className={classes.bar}>
        <Toolbar>
          <div className={classes.flex}>
            <img src={logo} alt="musicology studio" height={70} />
          </div>
          <Navigation />
        </Toolbar>
      </AppBar>
    )
  }
}

export default withStyles(styles)(Header);
